import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorStatuses } from '~shared/modules/error-handler';
import { ApiConfig } from '~shared/constants';
import { CSSHttpError } from '~shared/modules/error-handler/models/css-error.model';
import { deserialize } from 'serialize-ts';
import { authorizationEndpoints } from '../constants/authorization.constant';

@Injectable()
export class CSSValidationErrorInterceptor implements HttpInterceptor {
  constructor() {}

  private static transformError(error: HttpErrorResponse) {
    if (error.error.error === 'validationError') {
      return {
        ...error,
        ...deserialize(error.error, CSSHttpError),
      };
    }
    return error;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (
      !req.url.includes(ApiConfig.SVC_METRONOM_CSS_PROXY_BASE()) &&
      !req.url.includes(authorizationEndpoints().tierTwoAccount)
    ) {
      return next.handle(req);
    }
    return next.handle(req).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === HttpErrorStatuses.BadRequest) {
          const httpError = error && CSSValidationErrorInterceptor.transformError(error);
          return throwError(httpError);
        }
        return throwError(error);
      })
    );
  }
}
